import { useEffect } from "react";
import { useLocation } from "react-router-dom";

interface IUseMobileTopBottomColor {
  circadiaEngineProvider: ICircadiaEngineProvider;
}

export const useMobileTopBottomColor = ({
  circadiaEngineProvider,
}: IUseMobileTopBottomColor) => {
  const location = useLocation();
  useEffect(() => {
    // Function to update colors based on current hash

    const updateColors = () => {
      const path = location.pathname;

      // Public / pre-login screens — full mint
      if (
        path.includes("get-started") ||
        path.includes("login") ||
        path.includes("otp") ||
        path.includes("otp-verification") ||
        path.includes("patient-profile") ||
        path.includes("notification-settings") ||
        path.includes("floor-settings")
      ) {
        circadiaEngineProvider.changeAppTopAndBottom("#ebfdff", "#ebfdff");
        return;
      }

      // Patient-app legacy chime screens — solid navy
      if (
        path.includes("flag/chime") ||
        path.includes("bed-exit/chime") ||
        path.includes("escalation/chime")
      ) {
        circadiaEngineProvider.changeAppTopAndBottom("#161646", "#161646");
        return;
      }

      if (path.includes("ai-coach")) {
        circadiaEngineProvider.changeAppTopAndBottom("#f8fafb", "#f8fafb");
        return;
      }

      // Field-Setup: Setup steps and Dashboard share the mint→white gradient.
      if (path === "/dashboard" || path.startsWith("/dashboard/")) {
        circadiaEngineProvider.changeAppTopAndBottom("#ffffff", "#ffffff");
        return;
      }

      // Field-Setup tabs that have a tab bar at the bottom — mint top, white bottom
      // so the tab bar's white surface flows into the home-indicator strip.
      if (path === "/users" || path === "/profile") {
        circadiaEngineProvider.changeAppTopAndBottom("#ffffff", "#ffffff");
        return;
      }

      // Patient-app legacy connect-device flow
      if (path.includes("connect-device") || path.includes("/setup")) {
        circadiaEngineProvider.changeAppTopAndBottom("#f8fafb", "#ffffff");
        return;
      }

      circadiaEngineProvider.changeAppTopAndBottom("#f8fafb", "#f8fafb");
    };
    updateColors();
  }, [location.pathname]);

  return null;
};
